import styled from 'styled-components';
import { CartClose } from '../../__partials/CartClose';

export const Close = styled(CartClose)`
  margin-left: auto;
`;
